/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_7_P1Inputs */

const en_terms_section_7_p1 = /** @type {(inputs: Terms_Section_7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This website links to services we do not run, among them GitHub, Cal.com for booking a call, and social platforms.`)
};

const lv_terms_section_7_p1 = /** @type {(inputs: Terms_Section_7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šī tīmekļvietne satur saites uz pakalpojumiem, ko neuzturam mēs, tostarp GitHub, Cal.com sarunas pieteikšanai un sociālajām platformām.`)
};

/**
* | output |
* | --- |
* | "This website links to services we do not run, among them GitHub, Cal.com for booking a call, and social platforms." |
*
* @param {Terms_Section_7_P1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_7_p1 = /** @type {((inputs?: Terms_Section_7_P1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_7_P1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_7_p1(inputs)
	return en_terms_section_7_p1(inputs)
});